import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Tooltip,
} from "@material-ui/core";
import Authorize from "../../../components/Authorize";
import {permissionProfiles} from "../../../components/Authorize/permissionProfiles";
import NotificationProvider from "../../../components/NotificationProvider";
import {useOverrideInspectionReadinessMutation} from "../vehicleSlice";

export const OverrideInspectionReadinessDialog = ({
    selectedRows,
    open,
    setOpen,
    reloadReadiness
}) => {
    let [overrideInspectionReadiness, { isLoading: isSaving }] = useOverrideInspectionReadinessMutation();

    const onClose = () => {
        setOpen(false);
    }

    const onSave = async () => {
        setOpen(false);
        const result = await overrideInspectionReadiness({
            vehicleIds: selectedRows
        });

        if (result && !result.error) {
            NotificationProvider.success("Successfully overrode Inspection Readiness");
            reloadReadiness && reloadReadiness();
        } else {
            NotificationProvider.error("Failed to override Inspection Readiness");
        }
    };

    return (
        <Authorize profile={permissionProfiles.ASSETS.ASSETS_PAGE_OVERRIDE_INSPECTION_READINESS}>
            <Dialog onClose={onClose} open={open} maxWidth='md' fullWidth>
                <DialogTitle>
                    Override Inspection Readiness
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} direction='column'>
                        <Grid item>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary" variant="outlined" >Cancel</Button>
                    <Tooltip title={'This will override the Inspection Readiness of the selected assets'}>
                        <span>
                            <Button onClick={onSave}
                                    color="primary" variant="contained"
                                    >Override Inspection Readiness for ({selectedRows?.length}) {selectedRows?.length > 1 ? 'Assets' : 'Asset'} </Button>
                        </span>
                    </Tooltip>
                </DialogActions>
            </Dialog>
        </Authorize>
    );
}